import { render } from "./AskAIChat.vue?vue&type=template&id=675f5339&scoped=true"
import script from "./AskAIChat.vue?vue&type=script&lang=js"
export * from "./AskAIChat.vue?vue&type=script&lang=js"

import "./AskAIChat.vue?vue&type=style&index=0&id=675f5339&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675f5339"]])

export default __exports__